
import { defineComponent } from 'vue'
import { mapGetters, mapState } from 'vuex'
import AsahiProgress from '@/components/library/AsahiProgress.vue'
import AllertCart from '@/components/library/assets/AllertCart.vue'
import SuccessCart from '@/components/library/assets/SuccessCart.vue'
import formatDateMixin from '@/utils/mixin'
import { constants } from '@/constants'

const HOMEPAGE_URL = '/'

export default defineComponent({
  components: {
    SuccessCart,
    AllertCart,
    AsahiProgress
  },
  mixins: [formatDateMixin],
  props: {
    changeMessageColor: {
      type: Boolean,
      default: false
    },
    messageType: {
      type: String,
      default: 'header'
    },
    mobile: {
      type: Boolean,
      default: false
    },
    isWhite: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      errorWeight: false,
      successWeight: false,
      isComponentVisible: false,
      errorWeightBar: false,
      isMobile: (window.innerWidth <= 768) || (this.messageType === 'mobile')
    }
  },
  computed: {
    ...mapState('basket', ['id', 'query', 'items', 'paymentMethod', 'shipmentId', 'isOnlyEmpties']),
    ...mapGetters('basket', ['progressBarSuccess', 'showProgressBarMessage']),
    ...mapState('catalog', ['alignment', 'shipTos']),

    checkNotEmpties () {
      return this.isOnlyEmpties !== '1'
    },

    progressBar () {
      return this.query?.progress_bar_data
    },

    isHomePge () {
      return this.$route.path === HOMEPAGE_URL
    },
    maxOrderCash () {
      return this.progressBar?.iMaximumOrderCash ?? 0
    },
    grandTotalYourPrice () {
      return this.query?.grand_total_your_price_details?.grand_total_your_price ?? 0
    },
    cashFilledPercentage () {
      return (this.grandTotalYourPrice / this.maxOrderCash) * 100
    },
    differenceResult () {
      return Math.round(this.maxOrderCash - this.grandTotalYourPrice)
    },
    totalCartPallet () {
      return this.progressBar?.iTotalCartPalletQty ?? 0
    },
    minimumOrderPallett () {
      return this.progressBar?.iMinimumOrderPallet ?? 0
    },

    messageColorClass () {
      if (this.changeMessageColor) {
        if (this.progressBarMessage.hasError) {
          return 'border-error-text'
        } else if (this.progressBarMessage.hasSucccess) {
          return 'border-success-text'
        } else {
          return 'border-default-text'
        }
      }
      return 'border-default-text'
    },

    isCompactAndFullTruck () {
      const customerType = localStorage.getItem('customertype')
      return this.messageType === 'compact' && (customerType === 'On Premise' || customerType === 'On Premise Franchisee')
    },
    isCompactAndNotFullTruck () {
      const customerType = localStorage.getItem('customertype')
      return this.messageType === 'compact' && !(customerType === 'On Premise' || customerType === 'On Premise Franchisee')
    },

    customerType (): any | undefined {
      if (this.user && this.user?.permissionSchema?.length > 0) {
        return this.user?.permissionSchema[0]?.rpDetails?.find((item: any) => item.customerType)
      }
      return undefined
    },

    progressBarMessage () {
      const type = this.customerType.customerType
      let progressbar = {
        title: '',
        subtitle: '',
        buttonTitle: '',
        hasError: false,
        hasSucccess: false
      }
      if (type === 'On Premise') {
        if (this.progressBar?.iTotalCartWeight <= this.progressBar?.iMinimumOrderWeight) {
          progressbar = {

            title: this.$t('Minimum order capacity not reached'),
            subtitle: this.$t('The minimum order capacity has not been reached, please add more goods'),
            buttonTitle: '',
            hasError: true,
            hasSucccess: false
          }
        } else if (this.progressBar?.iTotalCartWeight > this.progressBar?.iMaximumOrderWeight) {
          progressbar = {
            title: this.$t('Maximum weight exceeded'),
            subtitle: this.$t('The weight of the order exceeds the maximum order quantity, please reduce the quantity'),
            buttonTitle: '',
            hasError: true,
            hasSucccess: false
          }
        } else if (this.progressBar?.iTotalCartWeight >= this.progressBar?.iMinimumOrderWeight && this.progressBar?.iTotalCartWeight < constants.cartWeight.minOrderReach) {
          progressbar = {
            title: this.$t('Motrice discount not reached'),
            subtitle: this.$t('The Motrice discount has not yet been reached, please add more quantity (discount allowed between 12000 kg and 15999 kg)'),
            buttonTitle: '',
            hasError: false,
            hasSucccess: false
          }
        } else if (this.progressBar?.iTotalCartWeight > constants.cartWeight.minMotriceDiscount && this.progressBar?.iTotalCartWeight <= constants.cartWeight.motriceDiscountReached) {
          progressbar = {
            title: this.$t('Motrice discount reached'),
            subtitle: this.$t('The Motrice discount has been reached  (discount allowed between 12000 kg and 15999 kg)'),
            buttonTitle: '',
            hasError: false,
            hasSucccess: true
          }
        } else if (this.progressBar?.iTotalCartWeight >= constants.cartWeight.minAutotrenoDiscount && this.progressBar?.iTotalCartWeight <= constants.cartWeight.AutotrenoDiscountNotReached) {
          progressbar = {
            title: this.$t('Autotreno discount not reached'),
            subtitle: this.$t('The Autotrento discount has not yet been reached, please add more quantity (discount allowed reached 25260 kg)'),
            buttonTitle: '',
            hasError: false,
            hasSucccess: false
          }
        } else if (this.progressBar?.iTotalCartWeight >= constants.cartWeight.minAutotrenoDiscountNotReached && this.progressBar?.iTotalCartWeight <= this.progressBar?.iMaximumOrderWeight) {
          progressbar = {
            title: this.$t('Autotreno discount reached'),
            subtitle: this.$t('The Autotrento discount has been reached (discount allowed reached 25260 kg)'),
            buttonTitle: '',
            hasError: false,
            hasSucccess: true
          }
        }
      } else if (type === 'On Premise Franchisee') {
        if (this.progressBar?.iTotalCartWeight <= this.progressBar?.iMinimumOrderWeight) {
          progressbar = {
            title: this.$t('Minimum order capacity not reached'),
            subtitle: this.$t('The minimum order capacity has not been reached, please add more goods'),
            buttonTitle: '',
            hasError: true,
            hasSucccess: false
          }
        } else if (this.progressBar?.iTotalCartWeight >= this.progressBar?.iMinimumOrderWeight && this.progressBar?.iTotalCartWeight <= this.progressBar?.iMaximumOrderWeight) {
          progressbar = {
            title: this.$t('The minimum order capacity has been reached'),
            subtitle: this.$t('The minimum order capacity has been reached'),
            buttonTitle: '',
            hasError: false,
            hasSucccess: true
          }
        } else if (this.progressBar?.iTotalCartWeight > this.progressBar?.iMaximumOrderWeight) {
          progressbar = {
            title: this.$t('Maximum weight exceeded'),
            subtitle: this.$t('The weight of the order exceeds 290 quintals, reduce the quantity to proceed with the order'),
            buttonTitle: '',
            hasError: true,
            hasSucccess: false
          }
        }
      }
      this.$store.commit('basket/SET_PROGRESS_BAR_GLOBAL', progressbar)
      return progressbar
    },
    progressBarMiniMessage () {
      const difference = (this.maxOrderCash - this.grandTotalYourPrice).toFixed(2)
      if (this.progressBar?.isFullTruck || this.isEmptyTruck) {
        if (this.totalCartPallet <= 0) {
          return {
            title: `<b>${this.totalCartPallet} / ${this.minimumOrderPallett}</b> ${this.$t('pallets')}`,
            hasError: false,
            hasSucccess: false
          }
        }
        if (this.totalCartPallet < this.progressBar?.iMinimumOrderPallet) {
          // Reach minimum number of pallets:
          return {
            title: `<b>${this.totalCartPallet} / ${this.minimumOrderPallett}</b> ${this.$t('pallets')}`,
            hasError: true,
            hasSucccess: false
          }
        } else if (this.totalCartPallet >= this.progressBar?.iMinimumOrderPallet && this.totalCartPallet <= this.progressBar?.iMaximumOrderPallet && this.progressBar?.iTotalCartWeight < this.progressBar.iMaximumOrderWeight) {
          // Minimum number of pallets has been reached
          return {
            title: `<b>${this.totalCartPallet} / ${this.minimumOrderPallett}</b> ${this.$t('pallets')}`,
            hasError: false,
            hasSucccess: true
          }
        } else if (this.totalCartPallet > this.progressBar?.iMaximumOrderPallet) {
          // The maximum number of pallets has been exceeded.
          return {
            title: `<b>${this.totalCartPallet} / ${this.minimumOrderPallett}</b> ${this.$t('pallets')}`,
            hasError: true,
            hasSucccess: false
          }
        } else if (this.progressBar?.iTotalCartWeight > this.progressBar.iMaximumOrderWeight) {
          // The maximum weight has been exceeded.
          return {
            title: `<b>${this.progressBar?.iTotalCartWeight}Kg / ${this.progressBar?.iMaximumOrderWeight}Kg</b>`,
            hasError: true,
            hasSucccess: false
          }
        }
      } else {
        if (this.progressBar?.iTotalCartWeight <= 0) {
          return {
            title: `${this.$t('Reach minimum order capacity')} ${this.progressBar?.iMinimumOrderWeight}Kg`,
            hasError: false,
            hasSucccess: false
          }
        } else if (this.progressBar?.iTotalCartWeight !== 0 &&
          this.progressBar?.iTotalCartWeight >= this.progressBar?.iMinimumOrderWeight &&
          this.progressBar?.iTotalCartWeight < this.progressBar.iMaximumOrderWeight) {
          return {
            title: this.$t('Minimum order capacity has been reached.'),
            subtitle: '',
            hasError: false,
            hasSucccess: true
          }
        } else if (this.progressBar?.iTotalCartWeight > 0 &&
          this.progressBar?.iTotalCartWeight < this.progressBar?.iMinimumOrderWeight) {
          return {
            title: `${this.$t('Add')} ${this.$t('more.')}`,
            subtitle: `${this.$t('The minimum order capacity has not yet been reached, please add more goods.')}`,
            hasError: true,
            hasSucccess: false
          }
        } else if (this.progressBar?.iTotalCartWeight > 0 &&
          this.progressBar?.iTotalCartWeight > this.progressBar.iMaximumOrderWeight) {
          return {
            title: `${this.$t('Maximum weight exceeded')}`,
            subtitle: '',
            hasError: true,
            hasSucccess: false
          }
        }
      }
      return {
        title: '',
        subtitle: ''
      }
    },
    isEmptyTruck (): boolean {
      const emptyTypes = ['emptiesfulltruck_emptiesfulltruck']
      return emptyTypes.includes(this.query?.delivery_method)
    },
    isEmptyTransportType (): boolean {
      const emptyTypes = ['emptiespickup_emptiespickup', 'emptiesfulltruck_emptiesfulltruck']
      return emptyTypes.includes(this.query?.delivery_method)
    },
    isEmptyStandard (): boolean {
      const emptyTypes = ['emptiespickup_emptiespickup']
      return emptyTypes.includes(this.query?.delivery_method)
    },
    user () {
      return this.$store.state.auth.user
    },
    isWHSLUser () {
      const shipToIdFromStorage = this.shipTos[0]?.shiptosapid
      return this.user?.permissionSchema?.some((company) =>
        company.shipToId === shipToIdFromStorage &&
        company.rpDetails[0].rolename.includes('WHS')
      )
    }

  },
  methods: {
    getFillPercentage () {
      return this.progressBar?.iTotalCartWeight / this.progressBar?.iMaximumOrderWeight * 100
    },
    emitRequirementStatus () {
      const requirementMessage = this.progressBarMessage.buttonTitle
      this.$emit('requirement-status', requirementMessage)
    },
    emptiesDeliveryMethod () {
      const deliveryMethod = localStorage.getItem('shippingMethod')
      if (deliveryMethod === 'emptiespickup_emptiespickup') {
        return true
      }
    }
  }
})
